import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeglasses = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 15.5C2 14.6141 2.17723 13.7696 2.49816 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H3.80957C4.9925 9.76733 6.65664 9 8.5 9C10.3434 9 12.0075 9.76733 13.1904 11H18.8096C19.9925 9.76733 21.6566 9 23.5 9C25.3434 9 27.0075 9.76733 28.1904 11H30C30.5523 11 31 11.4477 31 12C31 12.5523 30.5523 13 30 13H29.5018C29.8228 13.7696 30 14.6141 30 15.5C30 19.0899 27.0899 22 23.5 22C19.9101 22 17 19.0899 17 15.5C17 14.6141 17.1772 13.7696 17.4982 13H14.5018C14.8228 13.7696 15 14.6141 15 15.5C15 19.0899 12.0899 22 8.5 22C4.91015 22 2 19.0899 2 15.5ZM8.5 11C6.01472 11 4 13.0147 4 15.5C4 17.9853 6.01472 20 8.5 20C10.9853 20 13 17.9853 13 15.5C13 13.0147 10.9853 11 8.5 11ZM23.5 11C21.0147 11 19 13.0147 19 15.5C19 17.9853 21.0147 20 23.5 20C25.9853 20 28 17.9853 28 15.5C28 13.0147 25.9853 11 23.5 11Z",
		fill: "currentColor"
	})
});
export default SvgEyeglasses;
